import { ModalWindow, UIText1, IconChevronRight16, IconDocument16, IconPhoto16, IconOpenFolder16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './AttachFileModal.css';
import { EMessageFileTypes } from '../../types/messageFiles';

type TAttachFileModalProps = {
  isOpen: boolean;
  isOfferShareAvailable: boolean;
  imageAccept: string;
  documentAccept: string;
  isDocumentUploadEnabled: boolean;
  onChange(event: React.ChangeEvent): void;
  onClick(type: EMessageFileTypes.Image | null): void;
  onClose(): void;
  onOfferSendClick(): void;
};

export const AttachFileModal: React.FC<TAttachFileModalProps> = ({
  isOpen,
  imageAccept,
  documentAccept,
  isOfferShareAvailable,
  isDocumentUploadEnabled,
  onChange,
  onClick,
  onClose,
  onOfferSendClick,
}) => {
  return (
    <ModalWindow open={isOpen} fixed onClose={onClose} size="M">
      <input id="image-upload" value="" type="file" accept={imageAccept} multiple onChange={onChange} />
      <label
        htmlFor="image-upload"
        className={styles['section']}
        onClick={() => onClick(EMessageFileTypes.Image)}
        data-name="AttachFileModal_photo"
      >
        <div className={styles['info']}>
          <IconPhoto16 />
          <UIText1>Фото</UIText1>
        </div>
        <IconChevronRight16 color="primary_100" />
      </label>
      {isDocumentUploadEnabled && (
        <>
          <input id="document-upload" value="" type="file" accept={documentAccept} multiple onChange={onChange} />
          <label
            htmlFor="document-upload"
            className={styles['section']}
            onClick={() => onClick(null)}
            data-name="AttachFileModal_document"
          >
            <div className={styles['info']}>
              <IconDocument16 />
              <UIText1>Документ</UIText1>
            </div>
            <IconChevronRight16 color="primary_100" />
          </label>
        </>
      )}
      {isOfferShareAvailable && (
        <label
          htmlFor="offer-attach"
          className={styles['section']}
          onClick={onOfferSendClick}
          data-name="AttachFileModal_offer"
        >
          <div className={styles['info']}>
            <IconOpenFolder16 />
            <UIText1>Моё объявление</UIText1>
          </div>
          <IconChevronRight16 color="primary_100" />
        </label>
      )}
    </ModalWindow>
  );
};
